// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"app-components-base-sharebutton--button","icon":"app-components-base-sharebutton--icon"};